import { Injectable } from '@angular/core';
import { AuthService } from './REST-API/rest.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuardService {
  constructor(private authService:AuthService,
    private router:Router) { }
  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot): boolean| 
  Observable<boolean |
  UrlTree> | 
  Promise<boolean> {
   return this.authService.user.pipe(map((user)=>{
     const isAuth = !!user
     if(isAuth){
      return true
     }else{
      return this.router.createUrlTree([''])
     }
    
   }))
  }
}
